import { trans } from '@spotahome/soyuz/client';

import LandingSellingPointsSection from '@spotahome/ui-library/src/tenant/components/LandingSellingPointsSection';

import EnvelopeIcon from './Icons/EnvelopeIcon';
import ClockIcon from './Icons/ClockIcon';
import KnittedIcon from './Icons/KnittedIcon';

const POINTS = [
  {
    titleKey: 'how_it_works.guarantees.block1.title',
    textKey: 'how_it_works.guarantees.block1.text',
    renderImage: className => <EnvelopeIcon className={className} />
  },
  {
    titleKey: 'how_it_works.guarantees.block2.title',
    textKey: 'how_it_works.guarantees.block2.text',
    renderImage: className => <ClockIcon className={className} />
  },
  {
    titleKey: 'how_it_works.guarantees.block3.title',
    textKey: 'how_it_works.guarantees.block3.text',
    renderImage: className => <KnittedIcon className={className} />
  }
];

const Guarantees = () => {
  return (
    <LandingSellingPointsSection
      title={trans('how_it_works.guarantees.title')}
      description={trans('how_it_works.guarantees.description')}
      subtitle={trans('how_it_works.spotahome.guarantee').toUpperCase()}
      points={POINTS}
      color="interaction"
    />
  );
};

export default Guarantees;
